import { http } from "@/shared/api/axios";
import {
  coverageRequestPageSchema,
  coverageRequestSchema,
  type CoverageRequest,
  type CoverageRequestPage,
  type CoverageRequestQuery,
} from "../model/types";

export async function fetchCoverageRequests(
  query: CoverageRequestQuery = {},
): Promise<CoverageRequestPage> {
  const { data } = await http.get("/v1/coverage-requests", {
    params: query,
    _skipErrorToast: true,
  } as never);
  return coverageRequestPageSchema.parse(data);
}

export async function fetchCoverageRequest(id: number): Promise<CoverageRequest> {
  const { data } = await http.get(`/v1/coverage-requests/${id}`, {
    _skipErrorToast: true,
  } as never);
  return coverageRequestSchema.parse(data);
}

export async function acceptCoverageRequest(id: number): Promise<CoverageRequest> {
  const { data } = await http.post(`/v1/coverage-requests/${id}/accept`, undefined, {
    _skipErrorToast: true,
  } as never);
  return coverageRequestSchema.parse(data);
}

export async function declineCoverageRequest(
  id: number,
  reason: string,
): Promise<CoverageRequest> {
  const { data } = await http.post(
    `/v1/coverage-requests/${id}/decline`,
    { reason },
    { _skipErrorToast: true } as never,
  );
  return coverageRequestSchema.parse(data);
}
